import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GroupsService } from "../services/groups.service";
import { AddDynamicGroupComponent } from "./add-dynamic-group/add-dynamic-group.component";
import { EditDynamicGroupComponent } from "./edit-dynamic-group/edit-dynamic-group.component";
import { eventDynamicGroupModel } from "./eventDyanmicGroupModel";
import * as moment from "moment";

@Component({
	selector: "app-events-assign-students",
	templateUrl: "./events-assign-students.component.html",
	styleUrls: ["./events-assign-students.component.css", "../groups.css"],
})
export class EventsAssignStudentsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private groupService: GroupsService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	subscription: any;

	SchoolLoading: any = true;
	EventLoading: any = true;
	GroupLoading: any = true;

	SelectedSchoolID: any = 0;
	SelectedEventID: any = 0;
	SelectedEventDescriptionID: any = 0;

	startDate: any = new Date();
	endDate: any = new Date();

	lstSchool: any = [];
	lstEvent: any = [];
	lstStudentGroups: any = [];
	lstEventDynamicGroups: any = []; //Formatted table data
	EventDyanmicGroupsList: any = []; //Raw data
	errorMessage: any = "";
	pagefirst: Number = 0;
	pagerows: Number = 10;

	//Filtering Data
	lstSchoolName: any = [];
	lstDynamicGroupDesc: any = [];
	lstDynamicGroupValue: any = [];
	lstAlertDesc: any = [];
	lstStatus: any = [];

	cols = [
		{ field: "SchoolName", header: "School" },
		{ field: "DynamicGroupDesc", header: "Selection" },
		{ field: "DynamicGroupValue", header: "Selection Value" },
		{ field: "AlertDesc", header: "Alert" },
		{ field: "Status", header: "Status" },
	];

	SelectedEventDynamicGroup: any;
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	private loadSchoolist() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SelectedSchoolID = this.lstSchool[0].SchoolID;

				this.SchoolLoading = false;

				this.loadEventList();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	private loadEventList() {
		var fsDate = moment(this.startDate).format("MM/DD/YYYY");
		var feDate = moment(this.endDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.SchoolLoading = false;
			this.EventLoading = false;
			this.GroupLoading = false;

			return;
		}

		this.EventLoading = true;

		// var result = this.groupService.loadEventList("", this.SelectedSchoolID, moment(this.startDate).format("MM/DD/YYYY"), moment(this.endDate).format("MM/DD/YYYY"), 'All');
		var result = this.groupService.C9EventsGetList(this.SelectedSchoolID, fsDate, feDate, 1);
		result.subscribe(
			(response) => {
				this.lstEvent = response;

				for (var i = 0; i < this.lstEvent.length; i++) {
					var next = this.lstEvent[i];

					next.EventDescLong = next.EventDescription.EventDescLong;
					next.EventDescShort = next.EventDescription.EventDescShort;
					next.EventDescriptionID = next.EventDescription.EventDescriptionID;
					// next.EventDT = next.EventDescription.EventDT;
				}

				// this.lstEvent = this.lstEvent.sort((a, b) => (a.EventDescShort + " " + this.FormatDate(a.EventDT)) < (b.EventDescShort + " " + this.FormatDate(b.EventDT)));

				if (this.lstEvent.length > 0) {
					this.SelectedEventID = this.lstEvent[0].EventID;
					this.SelectedEventDescriptionID = this.lstEvent[0].EventDescription.EventDescriptionID;

					//Get EventDescID
					// var entry;
					// for(var i = 0; i < this.lstEvent.length; i++){
					//   var next = this.lstEvent[i];
					//   if(next.EventID == this.SelectedEventID){
					//     entry = next;
					//   }
					// }
					// this.SelectedEventDescriptionID = entry.EventDescriptionID;
				} else {
					this.SelectedEventID = 0;
					this.SelectedEventDescriptionID = 0;

					//
					// No events for this school, cancel loading groups
					//
					// this.GroupLoading = false;
				}

				this.EventLoading = false;
				this.loadEventDynamicGroups();
			},
			(error) => {
				this.EventLoading = false;
			}
		);
	}

	private loadEventDynamicGroups() {
		this.GroupLoading = true;

		var result = this.groupService.loadEventDynamicGroupsList("", this.SelectedEventDescriptionID, 0);
		result.subscribe(
			(response) => {
				this.EventDyanmicGroupsList = response;

				//Update Data
				this.UpdateData();
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	UpdateData() {
		this.lstEventDynamicGroups = [];

		//Dropdown lists

		for (var i = 0; i < this.EventDyanmicGroupsList.length; i++) {
			var next = this.EventDyanmicGroupsList[i];

			var exclude = Number(next.IsExclude) == 1 ? "Exclude" : "Include";

			let val1: eventDynamicGroupModel = {
				EventDynamicGroupID: next.EventDynamicGroupID,
				SchoolID: next.SchoolID,
				SchoolName: next.SchoolName,
				DynamicGroupDesc: next.DynamicGroupDesc,
				DynamicGroupValue: next.DynamicGroupDisplay,
				AlertDesc: next.AlertDesc,
				Status: exclude,
			};

			this.lstEventDynamicGroups = [...this.lstEventDynamicGroups, val1];
		}

		this.lstSchoolName = Array.from(new Set(this.lstEventDynamicGroups.map((item: any) => item.SchoolName))).sort();
		this.lstDynamicGroupDesc = Array.from(new Set(this.lstEventDynamicGroups.map((item: any) => item.DynamicGroupDesc))).sort();
		this.lstDynamicGroupValue = Array.from(new Set(this.lstEventDynamicGroups.map((item: any) => item.DynamicGroupValue))).sort();
		this.lstAlertDesc = Array.from(new Set(this.lstEventDynamicGroups.map((item: any) => item.AlertDesc))).sort();
		this.lstStatus = Array.from(new Set(this.lstEventDynamicGroups.map((item: any) => item.Status))).sort();

		this.GroupLoading = false;
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onRefresh() {
		this.onChange();
	}

	onAdd() {
		this.errorMessage = "";

		//Error Handling
		if (this.SelectedEventID == 0) {
			this.errorMessage = "Select an Event to add an Event Dynamic Group to";
			return;
		}

		//Get Event Desc
		var entry;
		for (var i = 0; i < this.lstEvent.length; i++) {
			if (this.lstEvent[i].EventID == this.SelectedEventID) {
				entry = this.lstEvent[i];
			}
		}

		var EventDesc: any = "";
		EventDesc = entry.EventDescription.EventDescShort; //entry.EventDescShort;

		this.SelectedEventDescriptionID = entry.EventDescription.EventDescriptionID;

		//Create Popup
		var ref = this.dialogService.open(AddDynamicGroupComponent, {
			header: "Add Event Dynamic Group",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchoolID,
				EventDescShort: EventDesc,
				EventDescriptionID: this.SelectedEventDescriptionID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onChange();
			}
		});
	}

	onRowDblClick(val) {
		this.SelectedEventDynamicGroup = val;
		this.onEdit();
	}

	onEdit() {
		this.errorMessage = "";
		//Error Handling (Selected EventDynamicGroup)
		if (this.SelectedEventDynamicGroup == null) {
			this.errorMessage = "Select an entry to edit";
			return;
		}

		//Get Event Desc
		var entry;
		for (var i = 0; i < this.lstEvent.length; i++) {
			if (this.lstEvent[i].EventID == this.SelectedEventID) {
				entry = this.lstEvent[i];
			}
		}

		var EventDesc: any = "";
		EventDesc = entry.EventDescription.EventDescShort; //entry.EventDescShort;

		this.SelectedEventDescriptionID = entry.EventDescription.EventDescriptionID;

		entry = null;
		for (var i = 0; i < this.EventDyanmicGroupsList.length; i++) {
			if (this.EventDyanmicGroupsList[i].EventDynamicGroupID == this.SelectedEventDynamicGroup.EventDynamicGroupID) {
				entry = this.EventDyanmicGroupsList[i];
			}
		}

		var AlertID: any = "";
		AlertID = entry.AlertID;

		var DynamicGroup: any = "";
		DynamicGroup = entry.DynamicGroupID;

		var DynamicValue: any = "";
		DynamicValue = entry.DynamicGroupValue;

		//Create Popup
		var ref = this.dialogService.open(EditDynamicGroupComponent, {
			header: "Edit Event Dynamic Group",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedEventDynamicGroup.SchoolID,
				EventDynamicGroupID: this.SelectedEventDynamicGroup.EventDynamicGroupID,
				EventDescShort: EventDesc,
				EventDescriptionID: this.SelectedEventDescriptionID,
				DynamicGroupSelectID: DynamicGroup,
				DynamicValueSelectID: DynamicValue,
				AlertSelectID: AlertID,
				Exclude: this.SelectedEventDynamicGroup.Status == "Exclude" ? true : false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onChange();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";
		//Error handling
		if (this.SelectedEventDynamicGroup == null) {
			this.errorMessage = "Select an entry to delete";
			return;
		}

		//Call SP
		//Delete entry and reload table
		var result = this.groupService.DeleteEventDynamicGroup("", this.SelectedEventDynamicGroup.EventDynamicGroupID);
		result.subscribe(
			(response) => {
				this.onChange();
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////

	onSchoolChange(value) {
		this.SelectedSchoolID = value;
		this.SelectedEventID = 0;
		this.SelectedEventDescriptionID = 0;

		this.loadEventList();

		// this.onChange(); //Events load dyanmic groups
	}

	onHandleFilter(value) {}

	onHandleSort(value) {}

	onRowSelect(value) {
		//Reset Error Message
		this.errorMessage = "";

		//Set SelectedEventDynamicGroup
		this.SelectedEventDynamicGroup = value.data;
	}

	onRowUnselect(value) {
		this.SelectedEventDynamicGroup = null;
	}

	onEventChange(value) {
		if (this.lstEvent.length == 0) {
			this.SelectedEventID = 0;
		} else {
			this.SelectedEventID = value;
		}

		this.SelectedEventDescriptionID = 0;

		//Get EventDescID
		var entry;
		for (var i = 0; i < this.lstEvent.length; i++) {
			var next = this.lstEvent[i];
			if (next.EventID == this.SelectedEventID) {
				entry = next;
			}
		}

		this.SelectedEventDescriptionID = entry.EventDescription.EventDescriptionID;

		this.onChange();
	}

	onChange() {
		this.errorMessage = "";

		this.lstDynamicGroupDesc = [];
		this.lstDynamicGroupValue = [];
		this.lstAlertDesc = [];
		this.lstStatus = [];

		this.SelectedEventDynamicGroup = null;

		//Update table
		this.loadEventDynamicGroups();
	}

	onStartDateChange(val) {
		this.startDate = val;

		this.SelectedEventDynamicGroup = null;

		//Update table
		this.loadEventList();
	}

	onEndDateChange(val) {
		this.endDate = val;

		this.SelectedEventDynamicGroup = null;

		//Update table
		this.loadEventList();
	}

	/////////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////

	FormatDate(DT) {
		return moment(new Date(DT)).format("MM/DD/YYYY");
	}

	////////////////////////////////////
}
